<script>
import service from '@/service';

export default {
	methods: {
		showModal: function (id) {
			this.item_id = id;
			this.lastnik_selected = null;
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault()
			if (this.item_id != null && this.lastnik_selected != null) {
				service.zadrziVozilo(this.item_id, this.lastnik_selected.value)
					.then(response => {
						this.$refs.modal.hide();
						this.$emit('zadrzano-success');
					})
					.catch(error => {
						if (error) {
							console.log(error);
						}
					});
			}
		}
	},
	data: function () {
		return {
			item_id: null,
			lastnik_selected: null,
			lastnik_options: [
				{
					label: 'ATC',
					value: 'ATC'
				},
				{
					label: 'Strašek',
					value: 'STRAŠEK'
				},
				{
					label: 'AHPA',
					value: 'AHPA'
				}
			]
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Zadrži vozilo" class="modal-primary" ok-title="Potrdi" cancel-title="Prekliči" @ok="onOkModal">
		<b-row>
			<b-col>
				<b-form-group>
					<label>Lastnik</label>
					<v-select ref="lastnik"
						v-model="lastnik_selected"
						:options="lastnik_options"
						placeholder="Izberi lastnika ...">
					</v-select>
				</b-form-group>
			</b-col>
		</b-row>
	</b-modal>
</template>
<style>
.dropdown-toggle::after {
	border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ZadrzanoModal.vue